import { render, staticRenderFns } from "./ClassifierEditableValuesList.vue?vue&type=template&id=591f6db4&scoped=true&lang=pug&"
import script from "./ClassifierEditableValuesList.vue?vue&type=script&lang=js&"
export * from "./ClassifierEditableValuesList.vue?vue&type=script&lang=js&"
import style0 from "./ClassifierEditableValuesList.vue?vue&type=style&index=0&id=591f6db4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591f6db4",
  null
  
)

/* custom blocks */
import block0 from "./ClassifierEditableValuesList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports